import { NgModule } from "@angular/core";

import { BillingNotificationService } from "./billing-notification.service";

@NgModule({
  providers: [BillingNotificationService],
})
export class BillingServicesModule {}
